export const setDocumentTitle = ({ hubName }: { hubName?: string }) => {
  if (hubName) {
    document.title = `HG Home Guardian: ${hubName}`;
    return;
  }

  document.title = "HG Home Guardian";
};
